import React, { useState } from 'react';
import Papa from 'papaparse';
import { getToken } from '../../../utils/TokenUtils';
import { API_URL } from '../../../constants/api';
import '../css/ImportTab.css';

export default function ImportTab({ table }) {
  const [file, setFile] = useState(null);
  const [details, setDetail] = useState(null);
  const [importType, setImportType] = useState('csv');
  const [loading, setLoading] = useState(false);

  const token = getToken();

  const handleFileTypeChange = (type) => {
    setImportType(type);
    setFile(null);
    setDetail(null);
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const importCSV = async () => {
    if (!file) return alert('Please select a CSV file first!');

    setLoading(true);
    const url = `${API_URL}/api/sql/import-csv/${table}`;
    console.log('url:',url);
   Papa.parse(file, {
  header: true,
  skipEmptyLines: true,
  complete: async function (results) {
    const rows = results.data;
    const chunkSize = 100; // Adjust chunk size to stay under size limits
    
    setLoading(true);

    let totalSuccess = 0;
    let totalFailed = 0;
    let allDetails = [];
    let hasError = false;

    for (let i = 0; i < rows.length; i += chunkSize) {
      const chunk = rows.slice(i, i + chunkSize);
      console.log('JSON.stringify({ rows: chunk }):',JSON.stringify({ rows: chunk }))
      try {
        const res = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: token ? `Bearer ${token}` : '',
          },
          body: JSON.stringify({ rows: chunk }),
        });

        if (!res.ok) {
          hasError = true;
          console.error(`Batch ${i / chunkSize + 1} failed with status: ${res.status}`);
          break; // Stop further requests if a chunk fails
        }

        const result = await res.json();
        totalSuccess += result?.success || 0;
        totalFailed += result?.failed || 0;
        
        if (result?.details) {
          allDetails = allDetails.concat(result.details);
        }
      } catch (err) {
        hasError = true;
        console.error('Network or parsing error on batch:', err);
        alert(`Error processing batch starting at row ${i + 1}: ${err.message}`);
        break;
      }
    }

    setDetail(allDetails);
    setLoading(false);

    if (!hasError) {
      alert(`Import complete! Total Success: ${totalSuccess}, Total Failed: ${totalFailed}`);
    } else {
      alert('Import partially failed or stopped due to an error.');
    }
  },
});
  };

  const importSQL = async () => {
    if (!file) return alert('Please select a SQL file first!');

    setLoading(true);
    try {
      const text = await file.text();
      const res = await fetch(`${API_URL}/api/sql/import-sql/${table}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/sql',
          Authorization: token ? `Bearer ${token}` : '',
        },
        body: text,
      });

      if (res.ok) {
        alert('SQL imported successfully!');
      } else {
        alert('Failed to import SQL');
      }
    } catch (err) {
      alert(err);
    } finally {
      setLoading(false);
    }
  };

  const handleImport = (e) => {
    e.preventDefault();
    if (importType === 'csv') {
      importCSV();
    } else {
      importSQL();
    }
  };

  // return (
  //   <div className="pma-import-wrapper">
  //     <div className="pma-import-title">
  //       Importing into table <span className="pma-tablename">`{table}`</span>
  //     </div>

  //     <form onSubmit={handleImport}>
  //       {/* File Location Fieldset */}
  //       <fieldset className="pma-fieldset">
  //         <legend className="pma-legend">File to Import:</legend>
  //         <div className="pma-fieldset-content">
  //           <div className="pma-field-row">
  //             <label className="pma-label">Browse your computer:</label>
  //             <input
  //               type="file"
  //               className="pma-file-input"
  //               accept={importType === 'csv' ? '.csv' : '.sql'}
  //               onChange={handleFileChange}
  //             />
  //           </div>
  //           <div className="pma-info-text">(Max file size: 128MiB)</div>
  //         </div>
  //       </fieldset>

  //       {/* Format Selection Fieldset */}
  //       <fieldset className="pma-fieldset">
  //         <legend className="pma-legend">Format:</legend>
  //         <div className="pma-fieldset-content">
  //           <div className="pma-radio-group">
  //             <label className="pma-radio-label">
  //               <input
  //                 type="radio"
  //                 name="importFormat"
  //                 value="csv"
  //                 checked={importType === 'csv'}
  //                 onChange={(e) => handleFileTypeChange(e.target.value)}
  //               />
  //               <span>CSV</span>
  //             </label>
  //             <label className="pma-radio-label">
  //               <input
  //                 type="radio"
  //                 name="importFormat"
  //                 value="sql"
  //                 checked={importType === 'sql'}
  //                 onChange={(e) => handleFileTypeChange(e.target.value)}
  //               />
  //               <span>SQL</span>
  //             </label>
  //           </div>
  //         </div>
  //       </fieldset>

  //       {/* Format Specific Options Fieldset */}
  //       <fieldset className="pma-fieldset">
  //         <legend className="pma-legend">Format-Specific Options:</legend>
  //         <div className="pma-fieldset-content">
  //           {importType === 'csv' ? (
  //             <div className="pma-instructions">
  //               <strong>CSV Import Instructions:</strong>
  //               <ul>
  //                 <li>First row must contain column headers.</li>
  //                 <li>Each following row represents one database record.</li>
  //                 <li>Column names must match the destination table schema.</li>
  //               </ul>
  //             </div>
  //           ) : (
  //             <div className="pma-instructions">
  //               <strong>SQL Import Instructions:</strong>
  //               <ul>
  //                 <li>File must contain valid SQL query statements.</li>
  //                 <li>
  //                   Example:{' '}
  //                   <code>
  //                     INSERT INTO `{table}` (`col1`, `col2`) VALUES (...);
  //                   </code>
  //                 </li>
  //                 <li>
  //                   Multiple statements separated by semicolons are allowed.
  //                 </li>
  //               </ul>
  //             </div>
  //           )}
  //         </div>
  //       </fieldset>

  //       {/* Action Toolbar */}
  //       <div className="pma-import-toolbar">
  //         <button
  //           type="submit"
  //           className="pma-btn pma-btn-primary"
  //           disabled={loading}
  //         >
  //           {loading ? 'Importing...' : 'Go'}
  //         </button>
  //       </div>
  //     </form>

  //     {/* Results Section */}
  //     {details && details.length > 0 && (
  //       <div className="pma-results-section">
  //         <div className="pma-results-title">Import Results Details</div>
  //         <div className="table-responsive">
  //           <table className="pma-import-table">
  //             <thead>
  //               <tr>
  //                 <th style={{ width: '40px' }}>#</th>
  //                 <th>Name</th>
  //                 <th>Role</th>
  //                 <th>Phone</th>
  //                 <th>Email</th>
  //                 <th>Status</th>
  //                 <th>Error</th>
  //               </tr>
  //             </thead>
  //             <tbody>
  //               {details.map((r, index) => (
  //                 <tr key={index}>
  //                   <td>{index + 1}</td>
  //                   <td>{r.row?.name || '-'}</td>
  //                   <td>{r.row?.role || '-'}</td>
  //                   <td>{r.row?.phone || '-'}</td>
  //                   <td>{r.row?.email || '-'}</td>
  //                   <td>
  //                     <span
  //                       className={`pma-status-badge ${
  //                         r.status === 'success' ? 'success' : 'failed'
  //                       }`}
  //                     >
  //                       {r.status}
  //                     </span>
  //                   </td>
  //                   <td className="pma-error-cell">{r.error || '-'}</td>
  //                 </tr>
  //               ))}
  //             </tbody>
  //           </table>
  //         </div>
  //       </div>
  //     )}
  //   </div>
  // );
return (
    <div className="pma-import-wrapper">
      <div className="pma-import-title">
        Importing into table <span className="pma-tablename">`{table}`</span>
      </div>

      <form onSubmit={handleImport}>
        {/* File Location Fieldset */}
        <fieldset className="pma-fieldset">
          <legend className="pma-legend">File to Import:</legend>
          <div className="pma-fieldset-content">
            <div className="pma-field-row">
              <label className="pma-label">Browse your computer:</label>
              <input
                type="file"
                className="pma-file-input"
                accept={importType === 'csv' ? '.csv' : '.sql'}
                onChange={handleFileChange}
              />
            </div>
            <div className="pma-info-text">(Max file size: 128MiB)</div>
          </div>
        </fieldset>

        {/* Format Selection Fieldset */}
        <fieldset className="pma-fieldset">
          <legend className="pma-legend">Format:</legend>
          <div className="pma-fieldset-content">
            <div className="pma-radio-group">
              <label className="pma-radio-label">
                <input
                  type="radio"
                  name="importFormat"
                  value="csv"
                  checked={importType === 'csv'}
                  onChange={(e) => handleFileTypeChange(e.target.value)}
                />
                <span>CSV</span>
              </label>
              <label className="pma-radio-label">
                <input
                  type="radio"
                  name="importFormat"
                  value="sql"
                  checked={importType === 'sql'}
                  onChange={(e) => handleFileTypeChange(e.target.value)}
                />
                <span>SQL</span>
              </label>
            </div>
          </div>
        </fieldset>

        {/* Format Specific Options Fieldset */}
        <fieldset className="pma-fieldset">
          <legend className="pma-legend">Format-Specific Options:</legend>
          <div className="pma-fieldset-content">
            {importType === 'csv' ? (
              <div className="pma-instructions">
                <strong>CSV Import Instructions:</strong>
                <ul>
                  <li>First row must contain column headers.</li>
                  <li>Each following row represents one database record.</li>
                  <li>Column names must match the destination table schema.</li>
                </ul>
              </div>
            ) : (
              <div className="pma-instructions">
                <strong>SQL Import Instructions:</strong>
                <ul>
                  <li>File must contain valid SQL query statements.</li>
                  <li>
                    Example:{' '}
                    <code>
                      INSERT INTO `{table}` (`col1`, `col2`) VALUES (...);
                    </code>
                  </li>
                  <li>
                    Multiple statements separated by semicolons are allowed.
                  </li>
                </ul>
              </div>
            )}
          </div>
        </fieldset>

        {/* Action Toolbar */}
        <div className="pma-import-toolbar">
          <button
            type="submit"
            className="pma-btn pma-btn-primary"
            disabled={loading}
          >
            {loading ? 'Importing...' : 'Go'}
          </button>
        </div>
      </form>

      {/* Results Section */}
      {details && details.length > 0 && (
        <div className="pma-results-section">
          <div className="pma-results-title">Import Results Details</div>
          <div className="table-responsive">
            <table className="pma-import-table">
              <thead>
                <tr>
                  <th style={{ width: '40px' }}>#</th>
                  <th>Name</th>
                  <th>Role</th>
                  <th>Phone</th>
                  <th>Email</th>
                  <th>Status</th>
                  <th>Error</th>
                </tr>
              </thead>
              <tbody>
                {details.map((r, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{r.row?.name || '-'}</td>
                    <td>{r.row?.role || '-'}</td>
                    <td>{r.row?.phone || '-'}</td>
                    <td>{r.row?.email || '-'}</td>
                    <td>
                      <span
                        className={`pma-status-badge ${
                          r.status === 'success' ? 'success' : 'failed'
                        }`}
                      >
                        {r.status}
                      </span>
                    </td>
                    <td className="pma-error-cell">{r.error || '-'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
